"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _Box = _interopRequireDefault(require("../Box"));

var _styles = require("./styles");

var _Switch = _interopRequireDefault(require("./Switch.sizes"));

var _excluded = ["afterLabel", "beforeLabel", "checked", "className", "color", "id", "name", "style", "theme"];
var Switch = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var afterLabel = _ref.afterLabel,
      beforeLabel = _ref.beforeLabel,
      checked = _ref.checked,
      className = _ref.className,
      color = _ref.color,
      id = _ref.id,
      name = _ref.name,
      style = _ref.style,
      theme = _ref.theme,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var switchThemeSizes = (0, _Switch.default)(theme);
  var switchSize = switchThemeSizes.md;
  var leftColor = theme.colors[color] || theme.colors.neutral600;
  var switchId = id || name;
  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    paddingType: "square",
    paddingSize: "none",
    style: style,
    className: className
  }, /*#__PURE__*/_react.default.createElement(_styles.SwitchButton, Object.assign({
    appearance: switchSize
  }, rest), beforeLabel && /*#__PURE__*/_react.default.createElement(_styles.SwitchOption, {
    htmlFor: switchId,
    className: "switch-option-before",
    active: !checked
  }, beforeLabel), /*#__PURE__*/_react.default.createElement(_styles.SwitchInput, Object.assign({
    ref: ref,
    color: leftColor,
    id: switchId,
    name: name,
    checked: checked,
    appearance: switchSize,
    type: "checkbox"
  }, rest)), /*#__PURE__*/_react.default.createElement(_styles.SwitchLabel, Object.assign({
    htmlFor: switchId
  }, rest)), afterLabel && /*#__PURE__*/_react.default.createElement(_styles.SwitchOption, {
    htmlFor: switchId,
    className: "switch-option-after",
    active: checked
  }, afterLabel)));
});
Switch.defaultProps = {
  afterLabel: '',
  beforeLabel: '',
  checked: false,
  id: undefined,
  name: undefined
};

var _default = (0, _styledComponents.withTheme)(Switch);

exports.default = _default;